import { FormControl } from '@angular/forms';
import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { RespCenter } from './../models/resp-center.model';
import { ChargeIndicator } from './../models/charge-indicator.model';
import { RespCenterMap } from './../models/resp-center-map.model';
import { HttpClient } from '@angular/common/http';
import { WorkOrderType } from './../models/work-order-type.model';
import { StateOption } from './../models/state-option.model';
import { AssetLocation } from './../models/asset-location.model';
import { MajorLocation } from './../models/major-location.model';
import { ContractAdmin } from './../models/contract-admin.model';
import { DataService } from './../services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivityDialogComponent } from './../activity-dialog/activity-dialog.component';
import { Router } from '@angular/router';
import { ConfidenceOptions } from '../models/confidence-options.model';
import { ProjectDataService } from './../services/project-data.service';
import { Component, OnInit } from '@angular/core';
import { scan, startWith, map } from 'rxjs/operators';
import { OperatingUnit } from '../models/operating-unit.model';
import { ConfigService } from '../services/config.service';
import { sortBy, orderBy } from 'lodash';

@Component({
  selector: 'app-charging-project-setup',
  templateUrl: './charging-project-setup.component.html',
  styleUrls: ['./charging-project-setup.component.scss'],
  standalone: false,
})
export class ChargingProjectSetupComponent implements OnInit {
  state: StateOption;
  businessUnit: string;
  fundingProjectID: string;
  projectName: string;
  operatingUnit: OperatingUnit;
  projectManager: string;
  estimatedStartDate: Date;
  estimatedInServiceDate: Date;
  powerPlanProjectType: WorkOrderType;
  majorLocation: MajorLocation;
  projectChargeIndicator: string;
  respCenter: RespCenter;
  contractAdmin: ContractAdmin;
  assetLocation: AssetLocation;
  projectLongDescription: string;
  projectTypeOptions: ConfidenceOptions[];
  majorLocationOptions: MajorLocation[];
  indicatorOptions: ConfidenceOptions[];
  additionalProjectTypeVisible: boolean;
  additionalMajorLocationVisible: boolean;
  additionalIndicatorVisible: boolean;
  additionalProjectTypes: string[];
  additionalMajorLocations: MajorLocation[];
  additionalIndicators: string[];
  additionalSelectedProjectType: WorkOrderType;
  additionalSelectedMajorLocation: MajorLocation;
  additionalSelectedIndicator: string;
  longDescriptionComplete: boolean;
  longDescriptionSubmitted: boolean;
  contractAdminOptions: ContractAdmin[];
  assetLocationOptions: AssetLocation[];
  todayDate: string;
  stateOptions: StateOption[];
  businessUnitOptions: string[];
  assetLocationsFound: boolean;
  fundingProjectType: string;
  workOrderTypeOptions: WorkOrderType[];
  respCenterMap: RespCenterMap[];
  additionalWorkOrderTypes: WorkOrderType[];
  chargeIndicatorOptions: ChargeIndicator[];
  additionalChargeIndicatorOptions: ChargeIndicator[];
  respCenterChoices: RespCenter[];
  total: number;
  limit: number;
  offset: number;
  options = new BehaviorSubject<RespCenter[]>([]);
  options$: Observable<RespCenter[]>;
  standardActivities: string[];
  lateWaitPeriod: string;
  costEstimate: number;
  loadingChargeIndicator: boolean;
  operatingUnitOptions: OperatingUnit[];

  respCenterControl = new FormControl();
  filteredRespCenterOptions: Observable<RespCenter[]>;
  lastFilter: string = '';

  contractAdminControl = new FormControl();
  filteredContractAdminOptions: Observable<ContractAdmin[]>;
  contractAdminLastFilter: string = '';

  constructor(
    private projectDataService: ProjectDataService,
    private router: Router,
    private dialog: MatDialog,
    private dataService: DataService,
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.options$ = this.options.asObservable().pipe(
      scan((acc, curr) => {
        return [...acc, ...curr];
      }, [])
    );
  }

  ngOnInit() {
    this.loadingChargeIndicator = false;
    //this.getProjectDataFromService();
    this.filteredRespCenterOptions = this.respCenterControl.valueChanges.pipe(
      startWith<string | RespCenter[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.respCenterFilter(filter))
    );
    this.filteredContractAdminOptions = this.contractAdminControl.valueChanges.pipe(
      startWith<string | ContractAdmin[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.contractAdminFilter(filter))
    );
    this.respCenterChoices = [];
    this.majorLocationOptions = [];
    this.contractAdminOptions = [];
    this.chargeIndicatorOptions = [];
    this.loadProjectData();
    this.setOperatingUnit();
    //this.loadRespCenterMapFile();
    this.loadRespCenterChoicesFile();
    this.getSuggestions();
    this.additionalProjectTypeVisible = false;
    this.additionalMajorLocationVisible = false;
    this.additionalIndicatorVisible = false;
    this.getProjectTypes();
    this.getIndicators();
    //this.longDescriptionComplete = false;
    //this.longDescriptionSubmitted = false;
    //this.setMajorLocationPrimary();
    if (
      !this.additionalWorkOrderTypes ||
      !this.additionalMajorLocations ||
      this.additionalWorkOrderTypes.length == 0 ||
      this.additionalMajorLocations.length == 0
    ) {
      this.getMajorLocationAlternates();
    }
    if (!this.contractAdminOptions || this.contractAdminOptions.length == 0) {
      this.getContractAdminChoices();
    }
    if (!this.workOrderTypeOptions || this.workOrderTypeOptions.length == 0) {
      this.getWorkOrderTypeChoices();
    }
    //this.getActivitiesTEST();
    this.generateTodaysDate();
  }

  displayFnRespCenter(value: RespCenter): string | undefined {
    if (!value) {
      return '';
    }
    return value.DEPARTMENT_ID + ' - ' + value.DESCR;
  }

  displayFnContractAdmin(value: ContractAdmin): string | undefined {
    if (!value) {
      return '';
    }
    return value.full_name;
  }

  /*getProjectDataFromService() {
    //this.state = this.projectDataService.projectData.state;
    this.businessUnit = this.projectDataService.projectData.businessUnit;
    this.fundingProjectID = this.projectDataService.projectData.fundingProjectID;
    this.projectName = this.projectDataService.projectData.projectName;
    this.operatingUnit = this.projectDataService.projectData.operatingUnit;
    this.projectManager = this.projectDataService.projectData.projectManager;
    this.estimatedStartDate = this.projectDataService.projectData.estimatedStartDate;
    this.estimatedInServiceDate = this.projectDataService.projectData.estimatedInServiceDate;
    this.powerPlanProjectType = this.projectDataService.projectData.powerPlanProjectType;
    //this.majorLocation = this.projectDataService.projectData.majorLocation;
    this.projectChargeIndicator = this.projectDataService.projectData.projectChargeIndicator;
    this.respCenter = this.projectDataService.projectData.respCenter;
    this.contractAdmin = this.projectDataService.projectData.contractAdmin;
    //this.assetLocation = this.projectDataService.projectData.assetLocation;
    this.projectLongDescription = this.projectDataService.projectData.projectLongDescription;
  }*/

  respCenterFilter(filter: string): RespCenter[] {
    this.lastFilter = filter;
    if (filter) {
      return this.respCenterChoices.filter((option) => {
        return option.DEPARTMENT_ID.concat(' - ')
          .concat(option.DESCR)
          .toLowerCase()
          .startsWith(filter.toLowerCase());
      });
    } else {
      return [];
    }
  }

  contractAdminFilter(filter: string): ContractAdmin[] {
    this.contractAdminLastFilter = filter;
    if (filter) {
      return this.contractAdminOptions.filter((option) => {
        return option.full_name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return [];
    }
  }

  loadProjectData() {
    let respCenterCheck = sessionStorage.getItem('respCenter');
    if (respCenterCheck) {
      this.respCenter = JSON.parse(respCenterCheck);
    } else {
      let fundingRespCenterCheck = sessionStorage.getItem('fundingProjectRespCenter');
      if (fundingRespCenterCheck) {
        this.respCenter = JSON.parse(fundingRespCenterCheck);
      } else {
        this.respCenter = null;
      }
    }
    let stateCheck = sessionStorage.getItem('state');
    if (stateCheck) {
      this.state = JSON.parse(stateCheck);
    } else {
      this.state = null;
    }
    this.businessUnit = sessionStorage.getItem('businessUnit');
    this.fundingProjectID = sessionStorage.getItem('fundingProjectID');
    this.projectName = sessionStorage.getItem('chargingProjectName');
    if (!this.projectName) {
      this.projectName = sessionStorage.getItem('projectName');
    }
    this.projectName = this.projectName.substring(0, 35);
    let operatingUnitCheck = sessionStorage.getItem('operatingUnit');
    if (operatingUnitCheck) {
      this.operatingUnit = JSON.parse(operatingUnitCheck);
    }
    this.projectManager = sessionStorage.getItem('projectManager');
    let startDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (startDateCheck) {
      /*Fixing off by one bug when loading date
      this.estimatedStartDate = new Date(startDateCheck);*/
      const [year, month, day] = startDateCheck.split('-').map(Number);
      this.estimatedStartDate = new Date(year, month - 1, day);
    } else {
      this.estimatedStartDate = null;
    }
    let inServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (inServiceDateCheck) {
      /*Fixing off by one bug when loading date
      this.estimatedInServiceDate = new Date(inServiceDateCheck);*/
      const [year, month, day] = inServiceDateCheck.split('-').map(Number);
      this.estimatedInServiceDate = new Date(year, month - 1, day);
    } else {
      this.estimatedInServiceDate = null;
    }
    let majorLocationCheck = sessionStorage.getItem('majorLocation');
    if (majorLocationCheck) {
      this.majorLocation = JSON.parse(majorLocationCheck);
    } else {
      this.majorLocation = null;
    }
    this.projectChargeIndicator = sessionStorage.getItem('projectChargeIndicator');
    let contractAdminCheck = sessionStorage.getItem('contractAdmin');
    if (contractAdminCheck) {
      this.contractAdmin = JSON.parse(contractAdminCheck);
    } else {
      this.contractAdmin = null;
    }
    let assetLocationCheck = sessionStorage.getItem('assetLocation');
    if (assetLocationCheck) {
      this.assetLocation = JSON.parse(assetLocationCheck);
    } else {
      this.assetLocation = null;
    }
    this.projectLongDescription = sessionStorage.getItem('chargingProjectLongDescription');
    if (!this.projectLongDescription) {
      this.projectLongDescription = sessionStorage.getItem('projectLongDescription');
    }
    this.projectLongDescription = this.projectLongDescription.replace(
      /[^\x00-\x7F\xB0\u2019\u201D]/g,
      ' '
    );
    this.projectLongDescription = this.projectLongDescription.substring(0, 254);
    let stateOptionsCheck = sessionStorage.getItem('stateOptions');
    if (stateOptionsCheck) {
      this.stateOptions = JSON.parse(stateOptionsCheck);
    } else {
      this.stateOptions = [];
    }
    let businessUnitOptionsCheck = sessionStorage.getItem('businessUnitOptions');
    if (businessUnitOptionsCheck) {
      this.businessUnitOptions = JSON.parse(businessUnitOptionsCheck);
    } else {
      this.businessUnitOptions = [];
    }
    let majorLocationOptionsCheck = sessionStorage.getItem('majorLocationOptions');
    if (majorLocationOptionsCheck) {
      this.majorLocationOptions = JSON.parse(majorLocationOptionsCheck);
    } else {
      let fundingProjectMajorLocationCheck = sessionStorage.getItem('fundingProjectMajorLocation');
      if (fundingProjectMajorLocationCheck) {
        this.majorLocationOptions = [JSON.parse(fundingProjectMajorLocationCheck)];
      } else {
        this.majorLocationOptions = [];
      }
    }
    let chargeIndicatorOptionsCheck = sessionStorage.getItem('chargeIndicatorOptions');
    if (chargeIndicatorOptionsCheck) {
      this.chargeIndicatorOptions = JSON.parse(chargeIndicatorOptionsCheck);
    } else {
      this.chargeIndicatorOptions = [];
    }
    let contractAdminOptionsCheck = sessionStorage.getItem('contractAdminOptions');
    if (contractAdminOptionsCheck) {
      this.contractAdminOptions = JSON.parse(contractAdminOptionsCheck);
    } else {
      this.contractAdminOptions = [];
    }
    let additionalWorkOrderTypeCheck = sessionStorage.getItem('additionalWorkOrderTypes');
    if (additionalWorkOrderTypeCheck) {
      this.additionalWorkOrderTypes = JSON.parse(additionalWorkOrderTypeCheck);
    } else {
      this.additionalWorkOrderTypes = [];
    }
    let additionalChargeIndicatorOptionCheck = sessionStorage.getItem(
      'additionalChargeIndicatorOptions'
    );
    if (additionalChargeIndicatorOptionCheck) {
      this.additionalChargeIndicatorOptions = JSON.parse(additionalChargeIndicatorOptionCheck);
    } else {
      this.additionalChargeIndicatorOptions = [];
    }
    let additionalMajorLocationCheck = sessionStorage.getItem('additionalMajorLocations');
    if (additionalMajorLocationCheck) {
      this.additionalMajorLocations = JSON.parse(additionalMajorLocationCheck);
    } else {
      this.additionalMajorLocations = [];
    }
    let assetLocationOptionCheck = sessionStorage.getItem('assetLocationOptions');
    if (assetLocationOptionCheck) {
      this.assetLocationOptions = JSON.parse(assetLocationOptionCheck);
      this.assetLocationsFound = true;
    } else {
      this.assetLocationOptions = [];
      this.assetLocationsFound = false;
    }
    let workOrderTypeOptionCheck = sessionStorage.getItem('workOrderTypeOptions');
    if (workOrderTypeOptionCheck) {
      this.workOrderTypeOptions = JSON.parse(workOrderTypeOptionCheck);
    } else {
      this.workOrderTypeOptions = [];
    }
    let operatingUnitOptionCheck = sessionStorage.getItem('operatingUnitOptions');
    if (operatingUnitOptionCheck) {
      this.operatingUnitOptions = JSON.parse(operatingUnitOptionCheck);
    } else {
      this.operatingUnitOptions = [];
    }
    let powerPlanProjectTypeCheck = sessionStorage.getItem('powerPlanProjectType');
    if (powerPlanProjectTypeCheck) {
      this.powerPlanProjectType = JSON.parse(powerPlanProjectTypeCheck);
    } else {
      this.powerPlanProjectType = null;
    }
    if (this.powerPlanProjectType) {
      let matchFound = false;
      for (let i = 0; i < this.workOrderTypeOptions.length && !matchFound; i++) {
        if (
          this.powerPlanProjectType.cosim == this.workOrderTypeOptions[i].cosim &&
          this.powerPlanProjectType.description == this.workOrderTypeOptions[i].description &&
          this.powerPlanProjectType.workOrderTypeId == this.workOrderTypeOptions[i].workOrderTypeId
        ) {
          this.powerPlanProjectType = this.workOrderTypeOptions[i];
          matchFound = true;
        }
      }
      if (!matchFound) {
        for (let i = 0; i < this.additionalWorkOrderTypes.length && !matchFound; i++) {
          if (
            this.powerPlanProjectType.cosim == this.additionalWorkOrderTypes[i].cosim &&
            this.powerPlanProjectType.description == this.additionalWorkOrderTypes[i].description &&
            this.powerPlanProjectType.workOrderTypeId ==
              this.additionalWorkOrderTypes[i].workOrderTypeId
          ) {
            this.powerPlanProjectType = this.additionalWorkOrderTypes[i];
            matchFound = true;
          }
        }
      }
    }
    let longDescriptionSubCheck = sessionStorage.getItem('longDescriptionSubmitted');
    if (longDescriptionSubCheck == 'true') {
      this.longDescriptionSubmitted = true;
    } else {
      this.longDescriptionSubmitted = false;
    }
    let longDescriptionCompCheck = sessionStorage.getItem('longDescriptionComplete');
    if (longDescriptionCompCheck == 'true') {
      this.longDescriptionComplete = true;
    } else {
      this.longDescriptionComplete = false;
    }
    this.fundingProjectType = sessionStorage.getItem('fundingProjectType');
    this.lateWaitPeriod = sessionStorage.getItem('lateWaitPeriod');
    let standardActivityCheck = sessionStorage.getItem('standardActivities');
    if (standardActivityCheck) {
      this.standardActivities = JSON.parse(standardActivityCheck);
    } else {
      this.standardActivities = [];
    }
    let additionalSelectedProjectTypeCheck = sessionStorage.getItem(
      'additionalSelectedProjectType'
    );
    if (additionalSelectedProjectTypeCheck) {
      this.additionalSelectedProjectType = JSON.parse(additionalSelectedProjectTypeCheck);
    } else {
      this.additionalSelectedProjectType = new WorkOrderType('', '');
    }
    let additionalSelectedMajorLocationCheck = sessionStorage.getItem(
      'additionalSelectedMajorLocation'
    );
    if (additionalSelectedMajorLocationCheck) {
      this.additionalSelectedMajorLocation = JSON.parse(additionalSelectedMajorLocationCheck);
    } else {
      this.additionalSelectedMajorLocation = new MajorLocation('', '');
    }
    if (this.additionalSelectedProjectType && this.additionalSelectedProjectType.description) {
      let matchFound = false;
      for (let i = 0; i < this.additionalWorkOrderTypes.length && !matchFound; i++) {
        if (
          this.additionalSelectedProjectType.cosim == this.additionalWorkOrderTypes[i].cosim &&
          this.additionalSelectedProjectType.description ==
            this.additionalWorkOrderTypes[i].description &&
          this.additionalSelectedProjectType.workOrderTypeId ==
            this.additionalWorkOrderTypes[i].workOrderTypeId
        ) {
          this.additionalSelectedProjectType = this.additionalWorkOrderTypes[i];
          matchFound = true;
        }
      }
    }
    if (this.majorLocation) {
      let matchFound = false;
      for (let i = 0; i < this.majorLocationOptions.length && !matchFound; i++) {
        if (
          this.majorLocation.major_loc_id == this.majorLocationOptions[i].major_loc_id &&
          this.majorLocation.major_location == this.majorLocationOptions[i].major_location
        ) {
          this.majorLocation = this.majorLocationOptions[i];
          matchFound = true;
        }
      }
      if (!matchFound) {
        for (let i = 0; i < this.additionalMajorLocations.length && !matchFound; i++) {
          if (
            this.majorLocation.major_loc_id == this.additionalMajorLocations[i].major_loc_id &&
            this.majorLocation.major_location == this.additionalMajorLocations[i].major_location
          ) {
            this.majorLocation = this.additionalMajorLocations[i];
            matchFound = true;
          }
        }
      }
    }
    if (
      this.additionalSelectedMajorLocation &&
      this.additionalSelectedMajorLocation.major_location
    ) {
      let matchFound = false;
      for (let i = 0; i < this.additionalMajorLocations.length && !matchFound; i++) {
        if (
          this.additionalSelectedMajorLocation.major_loc_id ==
            this.additionalMajorLocations[i].major_loc_id &&
          this.additionalSelectedMajorLocation.major_location ==
            this.additionalMajorLocations[i].major_location
        ) {
          this.additionalSelectedMajorLocation = this.additionalMajorLocations[i];
          matchFound = true;
        }
      }
    }
    this.additionalSelectedIndicator = sessionStorage.getItem('additionalSelectedIndicator');
    if (this.additionalSelectedIndicator == 'null') {
      this.additionalSelectedIndicator = null;
    }
    let costEstimateCheck = sessionStorage.getItem('costEstimate');
    if (costEstimateCheck) {
      this.costEstimate = Number(costEstimateCheck);
    } else {
      this.costEstimate = null;
    }
  }

  setOperatingUnit() {
    //Check if operatingUnit is null
    if (!this.operatingUnit || !this.operatingUnitOptions) {
      return;
    }
    for (let i = 0; i < this.operatingUnitOptions.length; i++) {
      if (this.operatingUnitOptions[i].OPERATING_UNIT === this.operatingUnit.OPERATING_UNIT) {
        this.operatingUnit = this.operatingUnitOptions[i];
      }
    }
  }

  loadRespCenterMapFile() {
    this.http.get('assets/resp-center-map.json').subscribe(
      (result) => {
        this.respCenterMap = result as RespCenterMap[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Resp Center Map Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Resp Center Map Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadRespCenterChoicesFile() {
    this.http.get('assets/resp-centers.json').subscribe(
      (result) => {
        this.respCenterChoices = result as RespCenter[];
        this.respCenterChoices = sortBy(this.respCenterChoices, ['DEPARTMENT_ID']);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Resp Center Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Resp Center Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  saveProjectData() {
    sessionStorage.setItem('chargingProjectName', this.projectName);
    if (this.estimatedStartDate) {
      sessionStorage.setItem(
        'estimatedStartDate',
        this.convertToDateStringFormat(this.estimatedStartDate)
      );
    }
    if (this.estimatedInServiceDate) {
      sessionStorage.setItem(
        'estimatedInServiceDate',
        this.convertToDateStringFormat(this.estimatedInServiceDate)
      );
    }
    sessionStorage.setItem('powerPlanProjectType', JSON.stringify(this.powerPlanProjectType));
    sessionStorage.setItem('majorLocation', JSON.stringify(this.majorLocation));
    sessionStorage.setItem('projectChargeIndicator', this.projectChargeIndicator);
    sessionStorage.setItem('respCenter', JSON.stringify(this.respCenter));
    sessionStorage.setItem('contractAdmin', JSON.stringify(this.contractAdmin));
    sessionStorage.setItem('assetLocation', JSON.stringify(this.assetLocation));
    sessionStorage.setItem(
      'chargingProjectLongDescription',
      this.projectLongDescription.replace(/[^\x00-\x7F\xB0\u2019\u201D]/g, ' ')
    );
    sessionStorage.setItem('majorLocationOptions', JSON.stringify(this.majorLocationOptions));
    sessionStorage.setItem('chargeIndicatorOptions', JSON.stringify(this.chargeIndicatorOptions));
    sessionStorage.setItem('contractAdminOptions', JSON.stringify(this.contractAdminOptions));
    sessionStorage.setItem(
      'additionalWorkOrderTypes',
      JSON.stringify(this.additionalWorkOrderTypes)
    );
    sessionStorage.setItem(
      'additionalMajorLocations',
      JSON.stringify(this.additionalMajorLocations)
    );
    sessionStorage.setItem(
      'additionalChargeIndicatorOptions',
      JSON.stringify(this.additionalChargeIndicatorOptions)
    );
    sessionStorage.setItem('assetLocationOptions', JSON.stringify(this.assetLocationOptions));
    sessionStorage.setItem('workOrderTypeOptions', JSON.stringify(this.workOrderTypeOptions));
    sessionStorage.setItem('additionalSelectedIndicator', this.additionalSelectedIndicator);
    if (this.costEstimate) {
      sessionStorage.setItem('costEstimate', this.costEstimate.toString());
    }
    if (this.longDescriptionSubmitted) {
      sessionStorage.setItem('longDescriptionSubmitted', 'true');
    } else {
      sessionStorage.setItem('longDescriptionSubmitted', 'false');
    }
    if (this.longDescriptionComplete) {
      sessionStorage.setItem('longDescriptionComplete', 'true');
    } else {
      sessionStorage.setItem('longDescriptionComplete', 'false');
    }
    sessionStorage.setItem('lateWaitPeriod', this.lateWaitPeriod);
    sessionStorage.setItem('standardActivities', JSON.stringify(this.standardActivities));
    sessionStorage.setItem(
      'additionalSelectedProjectType',
      JSON.stringify(this.additionalSelectedProjectType)
    );
    sessionStorage.setItem(
      'additionalSelectedMajorLocation',
      JSON.stringify(this.additionalSelectedMajorLocation)
    );
    sessionStorage.setItem('operatingUnit', JSON.stringify(this.operatingUnit));
  }

  convertToDateStringFormat(date: Date): string {
    return (
      date.getFullYear().toString() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0')
    );
  }

  generateTodaysDate() {
    let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    this.todayDate =
      today.getFullYear().toString() +
      '-' +
      (today.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      today.getDate().toString().padStart(2, '0');
  }

  /*saveProjectSetupData() {
    this.projectDataService.projectData.projectName = this.projectName;
    this.projectDataService.projectData.estimatedStartDate = this.estimatedStartDate;
    this.projectDataService.projectData.estimatedInServiceDate = this.estimatedInServiceDate;
    this.projectDataService.projectData.powerPlanProjectType = this.powerPlanProjectType;
    //this.projectDataService.projectData.majorLocation = this.majorLocation;
    this.projectDataService.projectData.projectChargeIndicator = this.projectChargeIndicator;
    //this.projectDataService.projectData.assetLocation = this.assetLocation;
    this.projectDataService.projectData.respCenter = this.respCenter;
    this.projectDataService.projectData.contractAdmin = this.contractAdmin;
    this.projectDataService.projectData.projectLongDescription = this.projectLongDescription;
  }*/

  getSuggestions() {
    this.projectTypeOptions = [
      {
        objectName: 'Charging Project 1',
        confidence: 80,
      },
      {
        objectName: 'Charging Project 2',
        confidence: 15,
      },
      {
        objectName: 'Charging Project 3',
        confidence: 5,
      },
    ];

    /*this.majorLocationOptions = [{
      objectName: 'Major Location 1',
      confidence: 80
    }];*/

    this.indicatorOptions = [
      {
        objectName: 'CWIP & RWIP',
        confidence: 99,
      },
      {
        objectName: 'CWIP',
        confidence: 15,
      },
      {
        objectName: 'RWIP',
        confidence: 5,
      },
    ];
  }

  goToPreviousPage() {
    this.saveProjectData();
    this.router.navigate(['/funding-project']);
  }

  launchActivityDialog() {
    if (this.longDescriptionSubmitted) {
      let dialogReference = this.dialog.open(ActivityDialogComponent, {
        disableClose: true,
        width: '43.75rem',
        height: '18.75rem',
      });
      dialogReference.componentInstance.onYes.subscribe(() => {
        //this.saveProjectSetupData();
        this.saveProjectData();
        sessionStorage.setItem('activitySelect', 'yes');
        this.router.navigate(['/activity-selection']);
      });
      dialogReference.componentInstance.onNo.subscribe(() => {
        //this.saveProjectSetupData();
        this.saveProjectData();
        sessionStorage.setItem('activitySelect', 'no');
        this.router.navigate(['/summary']);
      });
    } else {
      this.loadingChargeIndicator = true;
      this.getChargeIndicatorChoices();
    }
  }

  compareState(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.state == o2.state &&
      o1.major_loc_id == o2.major_loc_id &&
      o1.majorlocation == o2.majorlocation
    );
  }

  compareRespCenter(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.DEPARTMENT_ID == o2.DEPARTMENT_ID && o1.DESCR == o2.DESCR;
  }

  compareAssetLocation(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.ext_asset_location == o2.ext_asset_location && o1.long_description == o2.long_description
    );
  }

  compareContractAdmin(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.users == o2.users && o1.first_name == o2.first_name && o1.last_name == o2.last_name;
  }

  getProjectTypes() {
    this.additionalProjectTypes = ['Item', 'Item2', 'Item3', 'Item4', 'Item5'];
  }

  getIndicators() {
    this.additionalIndicators = ['Item', 'Item2', 'Item3', 'Item4', 'Item5'];
  }

  openAdditionalProjectTypes() {
    this.additionalProjectTypeVisible = true;
  }

  openAdditionalMajorLocations() {
    this.additionalMajorLocationVisible = true;
  }

  openAdditionalIndicators() {
    this.additionalIndicatorVisible = true;
  }

  closeAdditionalProjectTypes(workOrderTypeChoice?: WorkOrderType) {
    if (workOrderTypeChoice) {
      this.powerPlanProjectType = workOrderTypeChoice;
      this.additionalSelectedProjectType = workOrderTypeChoice;
    }
    this.additionalProjectTypeVisible = false;
  }

  closeAdditionalMajorLocations(majorLocation?: MajorLocation) {
    if (majorLocation) {
      this.majorLocation = majorLocation;
      this.additionalSelectedMajorLocation = majorLocation;
    }
    this.additionalMajorLocationVisible = false;
  }

  closeAdditionalIndicators(indicator?: ChargeIndicator) {
    if (indicator) {
      this.projectChargeIndicator = indicator.chargeIndicatorName;
      this.additionalSelectedIndicator = indicator.chargeIndicatorName;
    }
    this.additionalIndicatorVisible = false;
  }

  longDescriptionCompleteToggle() {
    this.longDescriptionComplete = !this.longDescriptionComplete;
  }

  /*setMajorLocationPrimary() {
    this.majorLocationOptions = [this.dataService.fundingProjectMajorLocation];
  }*/

  getMajorLocationAlternates() {
    this.additionalMajorLocations = [];
    let callBody = {
      fundProjId: this.fundingProjectID,
      businessUnit: this.businessUnit,
    };
    this.dataService.getAthenaData('pptype_ml_prchrgind', callBody).subscribe(
      (result) => {
        let startOfMajorLocationChoices = this.parseForWorkOrderTypeChoices(JSON.stringify(result));
        this.parseForMajorLocation(JSON.stringify(result).substring(startOfMajorLocationChoices));
        let matchFound = false;
        let compareMajorLocationID = this.majorLocationOptions[0].major_loc_id;
        for (let i = 0; i < this.additionalMajorLocations.length && !matchFound; i++) {
          if (this.additionalMajorLocations[i].major_loc_id == compareMajorLocationID) {
            this.additionalMajorLocations.splice(i, 1);
            matchFound = true;
          }
        }
        this.additionalMajorLocations = sortBy(this.additionalMajorLocations, ['major_location']);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Major Location Alternates Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Major Location Alternates Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getAssetLocationChoices() {
    this.assetLocationOptions = [];
    this.assetLocationsFound = false;
    let callBody = {
      majLocId: this.majorLocation.major_loc_id,
    };
    this.dataService.getAthenaData('asset_loc_ch', callBody).subscribe(
      (result) => {
        this.parseForAssetLocation(JSON.stringify(result));
        this.assetLocationsFound = true;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Asset Location Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Asset Location Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  /*getRespCenterChoices() {
    if (this.majorLocation && this.powerPlanProjectType) {
      console.log('triggered', this.majorLocation.major_loc_id, this.powerPlanProjectType.workOrderTypeId);
      let matchFound = false;
      for (let i = 0; i < this.respCenterMap.length; i++) {
        if (this.powerPlanProjectType.workOrderTypeId == this.respCenterMap[i].WORK_ORDER_TYPE_ID &&
          this.majorLocation.major_loc_id == this.respCenterMap[i].MAJOR_LOCATION_ID) {
            console.log('match found first pass', this.respCenterMap[i].EXTERNAL_DEPARTMENT_CODE);
            matchFound = true;
        }
      }
      if (!matchFound) {
        for (let i = 0; i < this.respCenterMap.length; i++) {
          if (this.powerPlanProjectType.workOrderTypeId == this.respCenterMap[i].WORK_ORDER_TYPE_ID) {
            console.log('match found second pass', this.respCenterMap[i].EXTERNAL_DEPARTMENT_CODE);
            matchFound = true;
          }
        }
      }
      if (!matchFound) {
        console.log('no match found');
      }
    }
  }*/

  getContractAdminChoices() {
    this.contractAdminOptions = [];
    let callBody = {};
    this.dataService.getAthenaData('cntrct_admin_ch', callBody).subscribe(
      (result) => {
        this.parseForContractAdmin(JSON.stringify(result));
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Contract Admin Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Contract Admin Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getWorkOrderTypeChoices() {
    this.workOrderTypeOptions = [];
    let callBody = {
      businessUnit: parseInt(this.businessUnit),
      fundingProjectType: this.fundingProjectType,
      wotDataBucket: this.config.getConfig('WotDataBucket'),
      wotDataKey: 'wot_ppln_data.json',
    };
    this.dataService.getWorkOrderTypeData(callBody).subscribe(
      (result) => {
        this.parseForWorkOrderType(JSON.stringify(result.body));

        for (let i = 0; i < this.workOrderTypeOptions.length; i++) {
          let matchFound = false;
          for (let j = 0; j < this.additionalWorkOrderTypes.length && !matchFound; j++) {
            if (
              this.additionalWorkOrderTypes[j].workOrderTypeId ==
              this.workOrderTypeOptions[i].workOrderTypeId
            ) {
              this.additionalWorkOrderTypes.splice(j, 1);
            }
          }
        }
        this.additionalWorkOrderTypes = sortBy(this.additionalWorkOrderTypes, ['description']);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Work Order Type Data Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Work Order Type Data Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getActivities() {
    let callBody = {
      workOrderTypeId: this.powerPlanProjectType.workOrderTypeId,
    };
    this.dataService.getAthenaData('activities_list', callBody).subscribe(
      (result) => {
        this.parseForActivities(JSON.stringify(result));
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Activities List Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Activities List Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  parseForActivities(arrayString: string) {
    this.standardActivities = [];
    let i = 2;
    let chargePeriodRecorded = false;
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let activityEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(activityEntry);
      if (!chargePeriodRecorded) {
        this.lateWaitPeriod = entryParse.late_chg_wait_period.trim();
        chargePeriodRecorded = true;
      }
      this.standardActivities.push(entryParse.job_task_id.trim());
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.standardActivities = this.standardActivities.sort();
  }

  getChargeIndicatorChoices() {
    let callBody = {
      description: this.projectLongDescription,
    };
    this.dataService.getChargeIndicatorData(callBody).subscribe(
      (result) => {
        this.parseForChargeIndicator(JSON.stringify(result));
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Charge Indicator Data Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Charge Indicator Data Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
        this.loadingChargeIndicator = false;
      }
    );
  }

  parseForChargeIndicator(arrayString: string) {
    let index = 1;
    this.chargeIndicatorOptions = [];
    while (arrayString[index] != '}') {
      let startOfName = index + 1;
      let endOfName = index + 1;
      while (arrayString[endOfName] !== '"') {
        endOfName++;
      }
      let indicatorName = arrayString.substring(startOfName, endOfName);
      let startOfConfidence = endOfName + 2;
      let endOfConfidence = endOfName + 2;
      while (arrayString[endOfConfidence] !== ',' && arrayString[endOfConfidence] !== '}') {
        endOfConfidence++;
      }
      let indicatorConfidence = Number(arrayString.substring(startOfConfidence, endOfConfidence));
      if (arrayString[endOfConfidence] == ',') {
        index = endOfConfidence + 1;
      } else {
        index = endOfConfidence;
      }
      this.chargeIndicatorOptions.push(new ChargeIndicator(indicatorName, indicatorConfidence));
    }
    for (let i = 0; i < this.chargeIndicatorOptions.length; i++) {
      if (this.chargeIndicatorOptions[i].chargeIndicatorName.includes('O&M')) {
        this.chargeIndicatorOptions[i].confidence = 0;
      }
    }
    this.chargeIndicatorOptions = orderBy(
      this.chargeIndicatorOptions,
      ['confidence', 'chargeIndicatorName'],
      ['desc', 'asc']
    );
    let percentCount = 0;
    for (let i = 0; i < this.chargeIndicatorOptions.length; i++) {
      if (this.chargeIndicatorOptions[i].confidence > 0) {
        percentCount++;
      }
    }
    if (percentCount < 3) {
      this.additionalChargeIndicatorOptions = this.chargeIndicatorOptions.slice(percentCount);
      this.chargeIndicatorOptions = this.chargeIndicatorOptions.slice(0, percentCount);
    } else {
      this.additionalChargeIndicatorOptions = this.chargeIndicatorOptions.slice(3);
      this.chargeIndicatorOptions = this.chargeIndicatorOptions.slice(0, 3);
    }
    this.additionalChargeIndicatorOptions = sortBy(this.additionalChargeIndicatorOptions, [
      'chargeIndicatorName',
    ]);
    this.loadingChargeIndicator = false;
    this.longDescriptionSubmitted = true;
  }

  parseForWorkOrderTypeChoices(arrayString: string): number {
    let i = 2;
    this.additionalWorkOrderTypes = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let workOrderTypeEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(workOrderTypeEntry);
      this.additionalWorkOrderTypes.push(
        new WorkOrderType(entryParse.description.trim(), entryParse.work_order_type_id.trim())
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForMajorLocation(arrayString: string) {
    let i = 1;
    this.additionalMajorLocations = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let majorLocationEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(majorLocationEntry);
      this.additionalMajorLocations.push(
        new MajorLocation(entryParse.major_location.trim(), entryParse.major_loc_id.trim())
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
  }

  parseForContractAdmin(arrayString: string) {
    let i = 2;
    this.contractAdminOptions = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let contractAdminEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(contractAdminEntry);
      let firstName = entryParse.first_name.trim();
      let lastName = entryParse.last_name.trim();
      this.contractAdminOptions.push(
        new ContractAdmin(entryParse.users.trim(), firstName, lastName, firstName + ' ' + lastName)
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.contractAdminOptions = sortBy(this.contractAdminOptions, ['last_name', 'first_name']);
  }

  parseForAssetLocation(arrayString: string) {
    let i = 2;
    this.assetLocationOptions = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let assetLocationEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(assetLocationEntry);
      if (
        !(entryParse.long_description.trim() as string).includes('ZZ -') &&
        !(entryParse.long_description.trim() as string).includes('NCNG')
      ) {
        this.assetLocationOptions.push(
          new AssetLocation(
            entryParse.ext_asset_location.trim(),
            entryParse.long_description.trim()
          )
        );
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.assetLocationOptions = sortBy(this.assetLocationOptions, ['long_description']);
  }

  parseForWorkOrderType(arrayString: string) {
    let i = 2;
    this.workOrderTypeOptions = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let workOrderTypeEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(workOrderTypeEntry);
      this.workOrderTypeOptions.push(
        new WorkOrderType(
          entryParse.description.trim(),
          entryParse.workOrderTypeId.toString(),
          entryParse.cosim
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    if (this.workOrderTypeOptions.length > 3) {
      this.workOrderTypeOptions.length = 3;
    }
    this.workOrderTypeOptions = orderBy(
      this.workOrderTypeOptions,
      ['cosim', 'description'],
      ['desc', 'asc']
    );
  }

  minimumInServiceDate() {
    if (this.estimatedStartDate) {
      return this.estimatedStartDate;
    } else {
      return this.todayDate;
    }
  }

  continueDisabled() {
    if (
      !this.longDescriptionComplete ||
      !this.estimatedStartDate ||
      !this.estimatedInServiceDate ||
      !this.projectLongDescription ||
      !this.projectName ||
      !this.costEstimate
    ) {
      return true;
    } else if (
      this.longDescriptionSubmitted &&
      (!this.powerPlanProjectType ||
        !this.majorLocation ||
        !this.projectChargeIndicator ||
        !this.assetLocation ||
        !this.respCenter ||
        !this.respCenter.DEPARTMENT_ID ||
        !this.contractAdmin ||
        !this.contractAdmin.full_name)
    ) {
      return true;
    } else {
      return false;
    }
  }

  exitPage() {
    this.router.navigate(['/dashboard']);
  }
}
